import jsonLogic from 'json-logic-js';

const arrayEQ = (arrA, arrB) => {
  if (arrA === arrB) return true;
  if (!Array.isArray(arrA) || !Array.isArray(arrB)) return false;
  if (arrA.length !== arrB.length) return false;
  const arrA_sorted = arrA.sort().toString();
  const arrB_sorted = arrB.sort().toString();
  return arrA_sorted === arrB_sorted;
};

const arrayNEQ = (arrA, arrB) => {
  return !arrayEQ(arrA, arrB);
};

jsonLogic.add_operation('arrayEQ', arrayEQ);
jsonLogic.add_operation('arrayNEQ', arrayNEQ);

export const MPCJsonLogic = jsonLogic;


// 应用jsonLogic条件判断
export function jsonLogicStrToBool(logicJson: string, row: any): boolean {
  try {
    let logicJsonObj = JSON.parse(logicJson);
    // 兼容错误配置数据,undefined
    if(logicJsonObj?.['undefined']) {
      logicJsonObj = {
        'and': logicJsonObj['undefined']
      }
    }
    return MPCJsonLogic.apply(logicJsonObj, row);
  } catch (e) {
    console.warn('解析或应用required的json条件失败！', e);
    return false;
  }
}


